import TransUnionButton from './TransUnionButton.view';

export default TransUnionButton;
